import React from 'react';
import { inject, observer } from 'mobx-react';

import H5SidebarUserInfo from './h5';
import PCSidebarUserInfo from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

// 获取本地配置的 API 域名
const API_BASE_URL = process.env.REACT_APP_API_BASE || '';

import SetPostAction from '@stores/setPost/action';

interface SidebarUserInfoProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    setPost?: SetPostAction;
    userInfo?: any;
    publishType?: any;   //发布按钮类型，默认为1，类型是发图文
    topicId?: any;
    isShowUserDetail?: any  // 是否显示用户头像和昵称
    showOtherInfo?: boolean // 是否显示他人的用户信息
    otherUserInfo?: any  // 他人的用户信息数据
    isFeedback?: boolean    // 是否是问题反馈
}

@inject('app', 'site', 'user', 'setPost')
@observer
class SidebarUserInfo extends React.Component<SidebarUserInfoProps> {
    componentDidMount() {}

    loginClick = () => {
        // 调用 user store 的登录校验
        const { user, app } = this.props;
        const platform = app?.platform || 'h5';
        if (user && typeof user.checkLogin === 'function') {
            user.checkLogin(platform);
        } else {
            // 备用方案：如果 user store 没有，直接跳转登录
            let OAUTH_URL = `${API_BASE_URL}/api/v3/users/vivo/oauth?platform=${platform}`;
            // 获取页面路径上的inviteCode参数
            const urlParams = new URLSearchParams(window.location.search);
            const inviteCode = urlParams.get('inviteCode');
            
            // 如果存在inviteCode，拼接到链接后面
            if (inviteCode) {
                OAUTH_URL += `&inviteCode=${encodeURIComponent(inviteCode)}`;
            }
            window.location.href = OAUTH_URL;
        }
    }
    // 发布按钮点击事件
    publishClick = () => {
        const { publishType = 1, topicId, setPost } = this.props;
        
        // 点击发图文时清空setPost数据，避免显示之前的编辑内容
        if (setPost && setPost.clearPostData) {
            console.log('[SidebarUserInfo] publishClick - 清空发帖数据');
            setPost.clearPostData();
        }
        
        if(topicId) {
            this.props.history && this.props.history.push(`/setPost?topicId=${topicId}`);
        } else {
            this.props.history && this.props.history.push(`/setPost`);
        }
        console.log('发布按钮点击', publishType, topicId);
    }

    // 去个人中心
    userClick = () => {
        let { user } = this.props;
        if (this.props.history && user?.code) {
            this.props.history.push(`/user/${user?.code}`);
        }
    }
    render() {
        const { site, app, showOtherInfo, otherUserInfo, ...props } = this.props;
        const platform = app?.platform || 'h5';
        // 确保传递 data 属性，即使为空数组
        if (platform === 'pc') {
            return <PCSidebarUserInfo {...props} showOtherInfo={showOtherInfo} otherUserInfo={otherUserInfo} loginClick={this.loginClick} userClick={(user) => this.userClick()} publishClick={this.publishClick} />;
        } else {
            return <H5SidebarUserInfo {...props} />;
        }


    }
}

export default withRouter(SidebarUserInfo);
